// @deprecated - Cookie contextwould only be used for CI in the future.
export const INITIAL_CONTEXT_COOKIE_NAME = "initial-context";
export const EXTERNAL_ACCOUNT_ID_COOKIE_NAME = "external-account-id";

// TODO: move entire SWR implementation into session
export const VISIT_LIST_KEY = "home-case-list";
export const TRIAGE_CASE_STATUS_KEY = "triage-case-status";
export const TRIAGE_LAST_MESSAGE_KEY = "triage-last-message";

/**
 * SWR configuration for visit list with mobile-first resilience
 */
export const VISIT_LIST_SWR_CONFIG = {
  revalidateOnFocus: true,
  revalidateOnReconnect: true,
  shouldRetryOnError: true,
  errorRetryInterval: 5000,
  errorRetryCount: 5,
  refreshInterval: 60000, // Poll every 60s; visit status does not need sub-minute freshness (PE-1667)
  dedupingInterval: 2000,
} as const;

/**
 * SWR configuration for triage card data with live syncing
 */
export const TRIAGE_SWR_CONFIG = {
  revalidateOnFocus: true,
  revalidateOnReconnect: true,
  shouldRetryOnError: true,
  errorRetryInterval: 3000,
  errorRetryCount: 3,
  refreshInterval: 30000, // Poll every 30s; native SDK context events cover faster updates (PE-1667)
  dedupingInterval: 1000, // Shorter deduping for more responsive updates
} as const;
